import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'


const app = createApp(App)

// ✅ Define global variables


app.config.globalProperties.$brand = 'Exactflo Suite'

// ✅ Use your plugins
app
  .use(store)
  .use(router)
  .use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 5,
    newestOnTop: true,
    position: 'top-right',
    timeout: 3000
  })

// ✅ Mount the app last
app.mount('#app')
